import { MenuItem, Select } from "@mui/material";
import { useState } from "react";
import DyanmicFromMobile from "../../DyanmicForm/DyanmicFromMobile";
import ActionMobileDrop from "../../ActionDropBar/ActionMobileDrop";

const SailingRestrictionInput = ({ data, setData }) => {
  const [activeRow, setActiveRow] = useState(0);
  const addPriceRow = () => {
    setData({
      ...data,
      data: [...(data.data || []), {}],
    });
  };

  let remark = [
    {
      title: "Text",
      key: "singleData",
      className: "col-lg-12",
      type: "multiLangarea",
    },
  ];
  let multiLangData = [
    {
      title: "Column 1",
      key: "col1",
      className: "col-lg-12",
      type: "multiLang",
    },
    {
      title: "Column 2",
      key: "col2",
      className: "col-lg-12",
      type: "multiLang",
    },
  ];
  const deletePriceRow = (index) => {
    if (data.data.length > 1) {
      const updateddata = data.data.filter((_, i) => i !== index);
      setData({ ...data, data: updateddata });
    }
  };

  const handlePriceChange = (index, field, value) => {
    const updateddata = [...data.data];
    updateddata[index] = value;
    setData({ ...data, data: updateddata });
  };

  return (
    <div style={{}} className="col-12 row ">
      <div className="col-12 row" style={{ marginBottom: "20px" }}>
        <div className="col-6">
          <label>Restriction Type</label>
          <Select
            value={data.type}
            style={{ width: "100%", height: "45px" }}
            onChange={(e) =>
              setData({
                ...data,
                type: e.target.value,
                data: e.target.value === "table" ? [{}] : [],
                singleData: e.target.value === "text" ? "" : undefined,
              })
            }
          >
            <MenuItem value="text">text</MenuItem>
            <MenuItem value="table">table</MenuItem>
          </Select>
        </div>
      </div>

      {/* text Price Input */}
      {data.type === "text" && (
        <div
          className="col-12"
          style={{
            display: "flex",
            padding: "10px",
            alignItems: "center",
            marginBottom: "15px",
            border: "1px solid gray",
          }}
        >
          <DyanmicFromMobile
            error={[]}
            rootData={data}
            level={1}
            attributes={remark || []}
            data={data || {}}
            setData={(e) => {
              setData(e);
            }}
          />
        </div>
      )}

      {/* table data */}
      {data.type === "table" &&
        data?.data?.map((priceRow, index) => (
          <div
            key={index}
            className="row col-12 card"
            style={{
              display: "flex",
              padding: "10px",
              alignItems: "center",
              marginBottom: "15px",
              border: "1px solid gray",
            }}
          >
            {activeRow === index ? (
              <div className="col-lg-12">
                {" "}
                <div
                  className="col-lg-12"
                  style={{
                    borderBottom: "1px solid black",
                    paddingBottom: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <ActionMobileDrop
                    title={`Restrictions ${index + 1}`}
                    active={activeRow === index}
                    setActive={() => setActiveRow()}
                    handleDelete={() => deletePriceRow(index)}
                  />
                </div>
                <DyanmicFromMobile
                  error={[]}
                  rootData={data}
                  level={1}
                  attributes={multiLangData || []}
                  data={priceRow || {}}
                  setData={(e) => {
                    handlePriceChange(index, "description", e);
                  }}
                />
              </div>
            ) : (
              <div
                onClick={() => setActiveRow(index)}
                className="col-12"
                style={{ color: "black", fontWeight: "bold", padding: "5px" }}
              >
                <ActionMobileDrop
                  title={
                    priceRow?.col1?.english || `Restrictions  ${index + 1}`
                  }
                  active={activeRow === index}
                  setActive={() => setActiveRow(index)}
                  handleDelete={() => deletePriceRow(index)}
                />
              </div>
            )}
          </div>
        ))}
      {data.type === "table" && (
        <button
          type="button"
          onClick={addPriceRow}
          style={{ maxWidth: "100px", marginLeft: "10px" }}
          className="btn main_submit"
        >
          Add Item
        </button>
      )}
    </div>
  );
};

export default SailingRestrictionInput;
